import tempMeeApi from '../../../apis/tempMee';

/**
 * Fetches child offices by parent office ID from the API
 *
 * @param {string} officeId - Parent office ID
 * @returns {Promise<import('../types/User.api').IGetChildOfficesApiResponse>} Child offices API response
 */
export const getChildOffices = async (officeId) => {
  const response = await tempMeeApi.get(`/admin/${officeId}/descend`);

  return response.data;
};
